"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoresInnerProductsInnerToJSON = exports.StoresInnerProductsInnerFromJSONTyped = exports.StoresInnerProductsInnerFromJSON = exports.instanceOfStoresInnerProductsInner = void 0;
var runtime_1 = require("../runtime");
var StoresInnerProductsInnerVariantsInner_1 = require("./StoresInnerProductsInnerVariantsInner");
/**
 * Check if a given object implements the StoresInnerProductsInner interface.
 */
function instanceOfStoresInnerProductsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoresInnerProductsInner = instanceOfStoresInnerProductsInner;
function StoresInnerProductsInnerFromJSON(json) {
    return StoresInnerProductsInnerFromJSONTyped(json, false);
}
exports.StoresInnerProductsInnerFromJSON = StoresInnerProductsInnerFromJSON;
function StoresInnerProductsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'styleId': !(0, runtime_1.exists)(json, 'style_id') ? undefined : json['style_id'],
        'name': !(0, runtime_1.exists)(json, 'name') ? undefined : json['name'],
        'variants': !(0, runtime_1.exists)(json, 'variants') ? undefined : (json['variants'] === null ? null : json['variants'].map(StoresInnerProductsInnerVariantsInner_1.StoresInnerProductsInnerVariantsInnerFromJSON)),
    };
}
exports.StoresInnerProductsInnerFromJSONTyped = StoresInnerProductsInnerFromJSONTyped;
function StoresInnerProductsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'style_id': value.styleId,
        'name': value.name,
        'variants': value.variants === undefined ? undefined : (value.variants === null ? null : value.variants.map(StoresInnerProductsInnerVariantsInner_1.StoresInnerProductsInnerVariantsInnerToJSON)),
    };
}
exports.StoresInnerProductsInnerToJSON = StoresInnerProductsInnerToJSON;
